import { TipoCambioService } from 'app/services/configuracion/tipo-cambio.service';

import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort ,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { DatePipe} from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../models/messages';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import { FiltrosCPE } from 'app/models/FiltrosCPE';
import { FacturacionCPEService } from './../../services/facturacion-cpe/facturacion-cpe.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;

@Component({
  selector: 'app-listado-cpe',
  templateUrl: './listado-cpe.component.html',
  styleUrls: ['./listado-cpe.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoCpeComponent implements OnInit {

  DTOFiltrosCPE: FiltrosCPE = new FiltrosCPE();
  loading:boolean;
  comprobantes : any = [];
  user:any;
  FechaIni: Date = new Date();
  FechaFin: Date = new Date();
  Fecha = moment();
  Monto: number;
  abrirPopUp:boolean = false;
  ruta : string;
  abrirDetalleReclamo:boolean = false;
  form: FormGroup;

  id;
  idCli ="" ;
  RUC_CLI : string;
  cliId = new FormControl();
  filteredCliente: Observable<any[]>;
  clientesArr;
  ruc = new FormControl();

  prueba:any;
  abrirDetalle : boolean = false;

  idComprobanteIF:number = 0;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns=[ 'checked','Moneda','Serie','Numero','Razon_Social','Fecha_Emision','Precio_Venta','Estado']
  dataSource: any;

  constructor(private serviceCPE: FacturacionCPEService,
    private datePipe:DatePipe,private router:Router,
    private cpeService:FacturacionCPEService,
    private tipoCambioService :TipoCambioService) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.FechaIni.setDate(this.FechaIni.getDate()-4);
    
    this.ObtenerClienteCombo();
   }

  ngOnInit() {
    let rutas = this.router.url.split("/",3);
    this.ruta = rutas[2];
    if (this.ruta == 'factura'){ 
        this.DTOFiltrosCPE.Tipo_Comprobante_CPE = "F";
    }else if (this.ruta == 'notaCredito'){
      this.DTOFiltrosCPE.Tipo_Comprobante_CPE  = "C";
    }
    else if (this.ruta == 'notaDebito'){
      this.DTOFiltrosCPE.Tipo_Comprobante_CPE  = "D";
    }
    this.ObternerTipoCambio();
  }

  ListadoCPEFiltro(){
    this.loading = true;
    this.cpeService.FiltrosListadoCPE(this.DTOFiltrosCPE,this.datePipe.transform(this.FechaIni,'yyyyMMdd'),this.datePipe.transform(this.FechaFin,'yyyMMdd')).subscribe(
      res =>{
         
          this.comprobantes = res['data']; 
          this.dataSource = new MatTableDataSource( this.comprobantes);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
      },err =>{
          Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false 
          });
          this.loading = false;
      }
    )
  }

  ObternerTipoCambio(){
    this.tipoCambioService.obtenerTipoCambio().subscribe(
      res =>{
        this.cpeService.TipoCambio = res;
      }
    )
  }

  CerrarDetalle(){
    this.abrirDetalle = false;
  }


  EnterobtenerRucRazSocialCli(termino :string = ''){
    let RUCempresa = '';
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
      for( let p of this.clientesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.id = p.idEmpresa;
            RUCempresa =p.Num_Doc_Identificacion;
          }
      }
      this.DTOFiltrosCPE.ClienteRuc = RUCempresa;
    }
  }

  obtenerId(provId :string){
    this.DTOFiltrosCPE.ClienteRuc = provId;
  }

  ObtenerClienteCombo() {
    this.clientesArr = JSON.parse(sessionStorage.getItem('lstCliCbo'));

      this.filteredCliente = this.cliId.valueChanges.pipe(
        startWith(""),
        map(state => state ? this._filterCli(state) : this.clientesArr.slice()
        )
      );
  }

  private _filterCli(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.clientesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  onClick(element:any){    
    this.idComprobanteIF = element.idComprobanteIF;
    this.abrirDetalle = true;
  }  

  eFactSend(element:any){

    Swal.fire({
      title: '',
      text: '¿Desea enviar comprobante Nro '+element.idComprobanteIF+' a Nubefact?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, enviar',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.cpeService.eFactEnviar(element.idComprobanteIF).subscribe(
          res =>{
            this.loading = false;
            Swal.fire({
              type: 'success',
              title: 'Éxito',
              text: '¡Enviado satisfactoriamente a Nubefact!',
              allowOutsideClick: false,
              heightAuto: false
            })
            this.ListadoCPEFiltro();
          },err =>{
            this.loading = false;
            Swal.fire({
                title: "¡Algo salió mal!",
                text:  err.error['error'],
                type: "warning",
                allowOutsideClick: true,
                heightAuto: false
            });
          }
        )
      }
    });
  }
}
